export default __webpack_public_path__ + "static/selfapp-self-text-be7ae7bb5f89a583f9cc2c2448495921.jpg";